<template>
  <div class="modal-backdrop">
    <div class="popup-content strategy-modal ">
      <h2 class="strategy-modal__title">Переключение эмоций: стратегия</h2>

      <div class="strategy-desc">
        <p>
          Чтобы перейти в эмоции <span :class="`targeted-color ${colorKey}`"> {{translateMap[colorKey]}} квадрата: </span>
        </p>
      </div>

      <div v-if="currentStrategy" class="strategy-desc-wrapper">
        <div class="strategy-text">
          {{ currentStrategy?.text ?? '' }}
        </div>

        <div v-if="currentStrategy" class="strategy-controls">
          <button class="btn btn-accent helpful-button" @click="() => recordStrategy('helpful')">
            Помогла
          </button>

          <button class="btn btn-accent unhelpful-button" @click="() => recordStrategy('unhelpful')">
            Не помогла
          </button>

          <button class="btn btn-accent show-more-button" @click="showMoreStrategies">
            Ещё
          </button>

          <div class="icon-button-controls">
            <div class="icon-button hide-button" @click="hideStrategy">
              <img v-if="hiddenStrategies.includes(currentStrategy.id)" src="@/assets/images/mood_tracker/eye-slash.svg" alt="Иконка зачеркнутого глаза">
              <img v-else  src="@/assets/images/mood_tracker/eye.svg" alt="Иконка глаза">
            </div>

            <div class="icon-button fav-button" @click="addStrategyToFavs">
              <img v-if="savedStrategies.includes(currentStrategy.id)" src="@/assets/images/mood_tracker/heart-filled.svg" alt="Иконка закращенного сердца">
              <img v-else src="@/assets/images/mood_tracker/heart.svg" alt="Иконка сердца">
            </div>
          </div>
        </div>
      </div>
      <div v-else class="strategy-desc-wrapper-loader">
        <mini-preloader />
      </div>
    </div>
  </div>
</template>

<script>
import BatteryIndicator from './BatteryIndicator.vue'
import {computed} from "@vue/reactivity";
import {useStore} from "vuex";
import CustomSelect from "@/components/Forms/Fields/CustomSelect.vue";
import {onBeforeMount, onBeforeUnmount, ref, watch} from "@vue/runtime-core";
import {notify} from "@kyvg/vue3-notification";
import {context} from "msw";
import MiniPreloader from "@/components/Technical/MiniPreloader.vue";

export default {
  name: 'StrategyModal',
  components: {
    MiniPreloader,
    CustomSelect,
    BatteryIndicator,
  },
  emits: ['close', 'changed'],
  props: {
    occurredTaskId: [String, Number],
    color: Object,
  },
  setup(props, context) {
    const store = useStore();
    const currentSettings = computed(() => store.state.tracker.settingsData);

    const unhelpfulStrategies = ref([]);
    const showedStrategies = ref([]);
    const hiddenStrategies = ref([]);
    const savedStrategies = ref([]);
    const currentStrategy = ref(null);
    const colorKey = computed(() => Object.keys(colorsMap).find(key => colorsMap[key] === props.color.name));
    const strategiesList = computed(() => store.state.tracker.availableStrategies);
    const currentStrategyFromViewedIndex = ref(0);

    const colorsMap = {
      red: 'Красный',
      yellow: 'Жёлтый',
      blue: 'Синий',
      green: 'Зелёный',
    };

    const translateMap = {
      red: 'Красного',
      yellow: 'Желтого',
      blue: 'Синего',
      green: 'Зеленого',
    };

    const addStrategyToFavs = () => {
      if (savedStrategies.value.includes(currentStrategy.value.id)) {
        savedStrategies.value = savedStrategies.value.filter((el) => el !== currentStrategy.value.id);
      } else {
        savedStrategies.value.push(currentStrategy.value.id);
      }

      store.dispatch('tracker/addStrategyToFavs', {strategy: currentStrategy.value.id});
    }

    const hideStrategy = () => {
      if (hiddenStrategies.value.length + 1 === strategiesList.value.length) {
        notify({
          title: "Нельзя скрыть все стратегии",
          type: "info"
        });
        return;
      }

      if (hiddenStrategies.value.includes(currentStrategy.value.id)) {
        hiddenStrategies.value = hiddenStrategies.value.filter((el) => el !== currentStrategy.value.id);
      } else {
        hiddenStrategies.value.push(currentStrategy.value.id);
      }

      store.dispatch('tracker/hideStrategy', {strategy: currentStrategy.value.id});
    }

    const recordStrategy = (type) => {
      store.dispatch('tracker/assignStrategyToTask', {
        strategy_id: currentStrategy.value.id,
        id: props.occurredTaskId,
        helpful: type === 'helpful',
      });

      if (type === 'unhelpful') {
        unhelpfulStrategies.value.push(currentStrategy.value.id);
        showMoreStrategies();
      }

      if (type === 'helpful') {
          context.emit('changed');
      }
    }

    const showMoreStrategies = () => {
      let nextStrategy = strategiesList.value.find((el) => !hiddenStrategies.value.includes(el.id) && !unhelpfulStrategies.value.includes(el.id) && !showedStrategies.value.includes(el.id));

      if (!nextStrategy) {
        if (currentStrategyFromViewedIndex.value < strategiesList.value.length) {
          currentStrategy.value = strategiesList.value.find((el) => el.id === showedStrategies.value[currentStrategyFromViewedIndex.value]);
          currentStrategyFromViewedIndex.value++;
        } else {
          currentStrategyFromViewedIndex.value = 0;
          currentStrategy.value = strategiesList.value.find((el) => el.id === showedStrategies.value[currentStrategyFromViewedIndex.value]);
        }
      } else {
        showedStrategies.value.push(nextStrategy.id);
        currentStrategy.value = nextStrategy;
      }
    }

    onBeforeMount(() => {
      store.dispatch('tracker/getStrategies', {color_id: props.color.id}).then(() => {
        if (strategiesList.value[0]) {
          currentStrategy.value = strategiesList.value[0];
          showedStrategies.value.push(strategiesList.value[0].id);

          strategiesList.value.map((el) => {
             if (el.is_favorite) {
               savedStrategies.value.push(el.id);
             }
          });
        }
      });
    });

    onBeforeUnmount(() => {
      store.commit('tracker/clearStrategies');
    });

    return {
      currentSettings,
      recordStrategy,
      hideStrategy,
      addStrategyToFavs,
      showMoreStrategies,
      currentStrategy,
      colorsMap,
      colorKey,
      translateMap,
      savedStrategies,
      hiddenStrategies
    }
  },
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: auto;
  display: flex;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.strategy-modal {
  position: relative;
  width: 900px;
  max-width: 100%;
  background: #f3f3f3;
  border-radius: 26px;
  padding: 26px 34px 28px;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
  margin: auto 0;
}

.strategy-modal {
  font-size: 16px;
  font-weight: 600;
}

@media (min-width: 901px) {
  .modal-backdrop {
    align-items: center;
  }
}

@media (max-width: 900px) {
  .modal-backdrop {
    align-items: flex-start;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .new-task-modal {
    margin: 0;
    border-radius: 20px;
  }
}

.strategy-modal__close {
  position: absolute;
  top: 18px;
  right: 18px;
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  color: #8f8f8f;
  cursor: pointer;
  padding: 0;
}

.strategy-modal__title {
  margin: 0 0 18px;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
}

.targeted-color {
  text-transform: uppercase;
  font-weight: 600;
}

.targeted-color.yellow {
  color: #ffec8a;
}

.targeted-color.green {
  color: #b0dc9c;
}

.targeted-color.blue {
  color: #8298cc;
}

.targeted-color.red {
  color: #f29175;
}

.strategy-controls {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: 900px) {
    flex-direction: column;

    .btn {
      width: 100%;
    }
  }
}

.icon-button-controls {
  margin-left: 20px;
  display: flex;
  gap: 8px;
}

.btn {
  border-radius: 16px;
  font-weight: 600;
}

.unhelpful-button {
  background-color: #dd6659;
  border-color: #dc6458;
}

.unhelpful-button:hover {
  background-color: #dd6659;
  border-color: #dc6458;
  opacity: 0.9;
}

.show-more-button {
  background-color: #ccc;
  border-color: #ccc;
}

.show-more-button:hover {
  opacity: 0.9;
  background-color: #ccc;
  border-color: #ccc;
}

.icon-button img {
  width: 30px;
  cursor: pointer;
}

.strategy-text, .strategy-desc {
  min-height: 60px;
  margin-bottom: 20px;
  font-weight: normal;
  text-align: center;
}

.strategy-desc-wrapper-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
}
</style>